import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getDiscountsOfferedService = async (payload) => {
  const response = await getData(`/discountOffered/getBySalesOffice?salesOfficeId=${payload}`);
  return response;
};

export const createDiscountsOfferedService = async (payload) => {
  const response = await putData("/discountOffered/create", payload);
  return response;
};

export const updateDiscountsOfferedService = async (id, payload) => {
  return await postData(`/discountOffered/update?discountOfferedId=${id}`, payload);
};

export const deleteDiscountsOfferedService = async (payload) => {
  return await deleteData(`/discountOffered/delete?discountOfferedId=${payload}`);
};

